import { DefaultError, UseQueryOptions, useQuery } from '@tanstack/react-query';
import { ContractProfile, ProtocolProfile, create_proto_profile } from '@ducat-unit/client-sdk';

import { getLogger } from '@/utils/loglevel';
import { VALIDATOR_URL } from '@/constants';

import { QueryKeys } from '../api/query-keys';
import { post } from '../api/api.helpers';
import { normalize_i0, normalize_rune_id } from './utils';

const logger = getLogger('useContractProfile', 'debug');

type ContractCtxParams = {
  masterId: string;
};

type QueryOptionsParam = Omit<UseQueryOptions<ProtocolProfile, DefaultError>, 'queryKey' | 'queryFn'>;

export function useContractProfile(params: ContractCtxParams, options?: QueryOptionsParam) {
  const url = `${VALIDATOR_URL}/api/protocol_profile`;
  const queryKey = [QueryKeys.contractProfile];

  return useQuery({
    queryKey,
    queryFn: async () => {
      const result: ContractProfile = await post(url, params);
      logger.debug(`result`, result);
      const protocolProfile = create_proto_profile(result, 'testnet');

      const profile: ProtocolProfile = {
        ...protocolProfile,
        master_id: normalize_i0(protocolProfile.master_id),
        runes: {
          ...protocolProfile.runes,
          unit: {
            ...protocolProfile.runes.unit,
            mint_id: normalize_i0(protocolProfile.runes.unit.mint_id),
            rune_id: normalize_rune_id(protocolProfile.runes.unit.rune_id),
            label: 'DUCAT•UNIT•RUNE',
          },
        },
      };
      logger.debug(`normalized protocol profile:`, profile);

      return profile;
    },
    staleTime: Infinity,
    ...options,
  });
}
